import { useEffect, useState } from "react";
import { ActivityIndicator, StyleSheet, View, Text } from "react-native";
import { AppColors } from "../utility/AppColors";
import React from "react";

export const ShowLoader = (props) => {
  const { showIndicater, isBackGround = false } = props;

  return showIndicater ? (
    <View
      style={[
        styles.containser,
        {
          backgroundColor: isBackGround ? AppColors.blackTrans_000000a8 : null,
        },
      ]}
    >
      <ActivityIndicator size="large" color={AppColors.white} />
    </View>
  ) : null;
};

const styles = StyleSheet.create({
  containser: {
    position: "absolute",
    height: "100%",
    width: "100%",
    // backgroundColor: AppColors.blackTrans_000000a8,
    opacity: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});
